//@ts-nocheck
import { FunctionComponent, memo } from 'react';
import Dialog from '@mui/material/Dialog';
import { AnimationContainer, Container, StyledLinearProgress } from './styles/GlobalLoadingStyles';
import { Fade } from '@mui/material';
import { RootState } from '../../stores/AppReducers';
import { connect, ConnectedProps } from 'react-redux';
import Lottie from 'react-lottie';
import LoadingAnimation from '../../assets/animations/loading.json';

const GlobalLoading: FunctionComponent<ScreenProps> = (props) => {

    const defaultOptions = {
        loop: true,
        autoplay: true,
        animationData: LoadingAnimation,
    };

    return (
        <Dialog
            fullScreen
            open={props.enabled}
            TransitionComponent={Fade}
        >
            <Container>
                <AnimationContainer>
                    <Lottie isClickToPauseDisabled options={defaultOptions} />
                </AnimationContainer>
            </Container>
        </Dialog>
    );
}

interface ScreenProps extends ReduxProps {

}

const mapStateToProps = (state: RootState) => ({
    enabled: state.globalLoading.enabled,
});
const connector = connect(mapStateToProps)
type ReduxProps = ConnectedProps<typeof connector>

export default connector(memo(GlobalLoading))